import { Dayjs } from 'dayjs'

import { RruleBydayEnum } from '../../sdk'

export function numberToDayEnum(dayNumber: number): RruleBydayEnum {
  const mapping: Record<number, RruleBydayEnum> = {
    0: RruleBydayEnum.Su,
    1: RruleBydayEnum.Mo,
    2: RruleBydayEnum.Tu,
    3: RruleBydayEnum.We,
    4: RruleBydayEnum.Th,
    5: RruleBydayEnum.Fr,
    6: RruleBydayEnum.Sa
  }

  return mapping[dayNumber]
}

export function getDateDetails(
  date: Dayjs | null,
  abbreviated?: boolean
): string {
  if (date === null) {
    return 'NA'
  }

  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]
  const nth = ['first', 'second', 'third', 'fourth', 'fifth']

  // Get the day of the week
  const day = weekDays[date.day()]

  // Determine which occurrence it is within the month
  const occurrence = Math.floor((date.date() - 1) / 7)

  if (abbreviated) {
    // Get the abbreviated day format
    const abbreviatedDay = day.slice(0, 2).toUpperCase()

    // Map to the RruleBydayEnum value
    return `${occurrence + 1}${abbreviatedDay}`
  }
  return `${nth[occurrence]} ${day}`
}
